import { createContext } from 'react'
import { ContextValue } from './types'

export default createContext<ContextValue>({
    user: null,
})
